/* ============================================================================
   WUNSCHSTART - AUSWAHL UND KALENDER (13.10.2026)

   WARUM EINE EIGENE DATEI: Diese Frage steht an zwei Orten, die nichts voneinander wissen -
   im Konfigurator (konfigurator.js, auf jeder Seite mit Kaufkasten) und auf der
   Warenkorbseite (templates/cart.liquid, wo konfigurator.js gar nicht laedt). Beide zeigen
   denselben Kalender; zweimal gebaut waere er zweimal zu pflegen, und der erste Unterschied
   zwischen den beiden faellt niemandem auf.

   SIE KENNT DEN ZUSTAND DES KONFIGURATORS NICHT. Uebergeben wird ein schlichtes Objekt
   { wahl, woche, datum }; wer es wohin speichert, entscheidet der Aufrufer. Im Konfigurator
   ist das A.startWunsch/startWoche/startDatum und der gespeicherte Stand, auf der
   Warenkorbseite die Eigenschaft der Bestellposition. Haette dieses Modul eine Meinung dazu,
   liefe es nur an einem der beiden Orte.

   SCHNITTSTELLE
     BwpStartwunsch.WAHL              die sechs Moeglichkeiten, in Leserichtung
     BwpStartwunsch.text(z)           "KW 48 · 23.11.–29.11.2026" / "im November 2026"
     BwpStartwunsch.roh(z)            "woche|2026-11-23||" - maschinenlesbar, fuer Eigenschaften
     BwpStartwunsch.ausRoh(s)         die Gegenrichtung
     BwpStartwunsch.html(id, z)       das Markup
     BwpStartwunsch.verdrahten(id, z, beiAenderung)

   DER KALENDER IST SELBST GEBAUT (Vorgabe Claras: "gerne auch im BWP-Design, wenn das geht"):
   Der Kalender des Browsers sieht in jedem Browser anders aus, laesst sich nicht gestalten -
   und kann vor allem keine WOCHE markieren. Ein eigenes Gitter kann beides mit derselben
   Oberflaeche: im Tagesmodus haengt die Markierung am Tag, im Wochenmodus an der Zeile.
   ============================================================================ */
(function(){
  'use strict';

  var VORLAUF_TAGE = 35;      /* 5 Wochen - dieselbe Frist, die der Kaufkasten zusagt */
  var FENSTER_TAGE = 548;     /* rund 18 Monate */
  /* FRUEHESTER START (15.10.2026, Vorgabe Claras: "mach bei 'wann es losgehen soll' bei der
     Auswahl, dass es nicht mehr moeglich ist, in 2026 zu starten").

     EINE GESCHAEFTSENTSCHEIDUNG, KEINE RECHNUNG - deshalb ein eigenes Datum und nicht eine
     groessere Vorlauffrist. VORLAUF_TAGE sagt, wie lange WIR von der Bestellung bis zur
     Lieferung brauchen (35 Tage, dieselbe Zusage wie im Kaufkasten); diese Zahl darf sich
     nicht aendern, nur weil das laufende Jahr voll ist. Mit 35 Tagen waeren vom 15.10.2026
     aus November und Dezember 2026 waehlbar gewesen.

     SIE ERLEDIGT SICH VON SELBST: Gilt wird immer das SPAETERE von beidem. Ab dem 28.11.2026
     liegt heute+35 hinter dem 01.01.2027, und ab da entscheidet wieder allein die
     Vorlauffrist - die Zeile muss niemand zurueckbauen. Wer sie fuer ein weiteres Jahr
     braucht, setzt das Datum hoch; wer sie nicht mehr will, setzt sie auf null.

     MONAT 1 IST FEBRUAR: new Date(2027,1,15) ist der 15. Februar 2027.

     MITTE FEBRUAR (28.10.2026, Vorgabe Claras: "mach beim Kalender im Konfigurator erst ab
     Mitte Februar moeglich, das Datum auszuwaehlen, egal ob beim genauen Datum oder der
     Woche"). Vorher stand hier der 18.01.2027 (Vorgabe vom 19.10.2026).

     DIESE EINE ZEILE REICHT FUER BEIDE MODI: Tag und Woche gehen durch minTag(), und
     minWoche() rundet von dort auf den naechsten ganzen Montag. Eine zweite Grenze gibt es
     nicht - wer sie sucht, sucht vergeblich.

     DER 15. UND NICHT DER 14. ODER 16. - nachgesehen, nicht geschaetzt:
       - Der 15.02.2027 IST EIN MONTAG. Die Wochenauswahl rundet auf den ganz hinter der
         Frist liegenden Montag auf; hier faellt sie auf genau dieses Datum und nicht eine
         Woche spaeter. Beim 14. (Sonntag) oder 16. (Dienstag) waere die erste waehlbare
         Woche der 22.02. geworden - eine Woche mehr, als Clara gesagt hat.
       - DER MONAT FEBRUAR BLEIBT WAEHLBAR: Ein Monat gilt als waehlbar, sobald sein LETZTER
         Tag hinter der Frist liegt. Das passt zum Hinweis, der von "ab Februar" spricht und
         nicht von "ab dem 15.". Wer grob "Februar" sagt, meint den Monat.
       - DER HINWEIS NENNT WEITER DEN MONAT, nicht den Tag - er liest den Monatsnamen aus
         genau diesem Datum und wechselt damit von selbst auf "Februar 2027". */
  var START_AB = new Date(2027, 1, 15, 12,0,0,0);

  var WAHL = [
    {k:'bald',     label:'Sobald es geht',          text:'sobald es möglich ist'},
    {k:'woche',    label:'Bestimmte Woche',         text:''},
    /* BESTIMMTER MONAT (14.10.2026, Vorgabe Claras: "fueg bei der Auswahlmoeglichkeit, wann man
       starten moechte, hinzu, dass man einen bestimmten Monat angeben kann").

       ER STEHT ZWISCHEN WOCHE UND "IN 3 MONATEN", weil die Liste von genau nach grob laeuft:
       Tag, Woche, Monat, Quartal, Halbjahr, weiss nicht. Zwischen "bestimmte Woche" und "in 3
       Monaten" klaffte bisher genau diese Stufe - wer weiss, dass er im Maerz anfangen will,
       musste sich zwischen einer Woche entscheiden, die er noch nicht kennt, und einem Zeitraum,
       der drei Monate breit ist. */
    {k:'monat',    label:'Bestimmter Monat',        text:''},
    /* "IN 3 MONATEN" IST AM 19.10.2026 ENTFALLEN (Vorgabe Claras). Es war die Stufe zwischen
       "bestimmter Monat" und "in 6 Monaten" - und seit die Auswahl ohnehin erst im Februar
       2027 beginnt (START_AB, am 28.10.2026 vom Januar dorthin verschoben), fiel sie mit
       "in 6 Monaten" praktisch zusammen: Von Oktober aus liegen beide im ersten Quartal.

       DIE KENNUNG 'quartal' BLEIBT IN ausRoh() LESBAR, ohne dass sie hier steht: Wer vor
       heute "in 3 Monaten" gewaehlt hat, traegt sie im gespeicherten Stand und in einem
       bereits abgeschickten Warenkorb. text() findet sie dann nicht mehr und gibt eine leere
       Zeile zurueck - das ist richtig so, denn die Antwort gibt es nicht mehr; die Frage
       steht beim naechsten Oeffnen wieder offen da. Ein stiller Umbau auf "in 6 Monaten"
       waere schlimmer: Er legte dem Kunden eine Antwort in den Mund, die er nie gegeben hat.

       "In 6 Monaten" statt "Im naechsten halben Jahr" (13.10.2026, Vorgabe Claras). */
    {k:'halbjahr', label:'In 6 Monaten',             text:'in den nächsten 6 Monaten'},
    {k:'unklar',   label:'Ich weiß es nicht',       text:'noch offen'}
  ];
  var WOCHENTAGE = ['Mo','Di','Mi','Do','Fr','Sa','So'];
  var MONATE = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

  /* Eigener Maskierer: Das Modul laeuft auch dort, wo konfigurator.js nicht geladen ist. */
  function esc(s){
    return String(s==null?'':s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }
  function zwei(n){ return String(n).padStart(2,'0'); }
  function tagText(d){ return d.getFullYear()+'-'+zwei(d.getMonth()+1)+'-'+zwei(d.getDate()); }
  function tagAus(iso){
    var t=String(iso||'').split('-');
    return t.length===3 ? new Date(+t[0],+t[1]-1,+t[2],12,0,0,0) : null;
  }
  /* Ortszeit, nicht toISOString(): Das rechnet nach UTC um und liefert in Deutschland im
     Sommer den Vortag, sobald jemand abends waehlt. Ein Kalender, dessen frueheste Wahl je
     nach Uhrzeit springt, ist schwer als Fehler zu erkennen. */
  function heutePlus(versatz){
    var d=new Date(); d.setHours(12,0,0,0); d.setDate(d.getDate()+versatz); return d;
  }
  /* Der Montag der Woche, in der dieser Tag liegt. Sonntag ist in getDay() die 0 und gehoert
     nach ISO zur Vorwoche - ohne diese Zeile spraenge eine Sonntagswahl eine Woche nach vorn. */
  function montagVon(iso){
    var d=tagAus(iso); if(!d) return null;
    d.setDate(d.getDate()-((d.getDay()+6)%7));
    return d;
  }
  /* Kalenderwoche nach ISO 8601 (DIN 1355): Die Woche mit dem ersten Donnerstag des Jahres ist
     die erste. Selbst gerechnet und nicht geschaetzt - eine um eins verschobene KW in einer
     Bestellung faellt erst auf, wenn jemand vergeblich auf die Lieferung wartet. */
  function kwVon(montag){
    var d=new Date(montag.getTime());
    d.setDate(d.getDate()+3);                        /* Donnerstag derselben Woche */
    var ersterDo=new Date(d.getFullYear(),0,4,12,0,0,0);
    ersterDo.setDate(ersterDo.getDate()-((ersterDo.getDay()+6)%7)+3);
    return 1+Math.round((d-ersterDo)/(7*24*3600*1000));
  }
  function minTag(){
    var d=heutePlus(VORLAUF_TAGE);
    return (START_AB && START_AB.getTime() > d.getTime()) ? new Date(START_AB.getTime()) : d;
  }
  /* AUFRUNDEN BEI DEN WOCHEN (Vorgabe Claras: "bei den Wochen dann eher aufrunden als
     abrunden"). Die Frist endet mitten in einer Woche; die waere nur zu drei Tagen buchbar.
     Angeboten wird deshalb erst die Woche, die GANZ dahinter liegt. */
  function minWoche(){
    var d=minTag(), m=montagVon(tagText(d));
    if(m && m.getTime() < d.getTime()) m.setDate(m.getDate()+7);
    return m;
  }
  function maxTag(){ return heutePlus(FENSTER_TAGE); }

  function wocheText(z){
    var m=montagVon(z && z.woche); if(!m) return '';
    var so=new Date(m.getTime()); so.setDate(so.getDate()+6);
    return 'KW '+kwVon(m)+' · '+zwei(m.getDate())+'.'+zwei(m.getMonth()+1)+'.–'
         + zwei(so.getDate())+'.'+zwei(so.getMonth()+1)+'.'+so.getFullYear();
  }
  function monatLesbar(z){
    var t=String((z&&z.monat)||'').split('-');
    return (t.length===2 && MONATE[+t[1]-1]) ? 'im '+MONATE[+t[1]-1]+' '+t[0] : '';
  }
  function tagLesbar(z){
    var t=String((z&&z.datum)||'').split('-');
    return t.length===3 ? 'ab '+t[2]+'.'+t[1]+'.'+t[0] : '';
  }
  function text(z){
    var w=null, i;
    for(i=0;i<WAHL.length;i++) if(WAHL[i].k===(z&&z.wahl)) w=WAHL[i];
    if(!w) return '';
    if(w.k==='woche') return wocheText(z);
    if(w.k==='monat') return monatLesbar(z);
    /* "Sobald es geht" mit Datum heisst "ab diesem Tag" - ohne Datum bleibt es die Absicht.
       Beides ist eine gueltige Antwort: Wer den Kalender oeffnet und nichts anklickt, hat
       "so frueh wie moeglich" gesagt und nicht weniger. */
    if(w.k==='bald' && z.datum) return tagLesbar(z);
    return w.text;
  }
  /* Maschinenlesbar fuer die Eigenschaft am Warenkorb-Posten. Der Klartext daneben ist fuer
     Menschen; aus ihm die Wahl zurueckzulesen hiesse, Datumsformate zu zerlegen - und beim
     ersten anders geschriebenen Monat ginge es schief. */
  /* DER MONAT HAENGT HINTEN AN (14.10.2026). Das ist mit Absicht die vierte Stelle und nicht
     etwa eine umsortierte: In Warenkoerben und Bestellungen stehen Zeichenketten mit drei
     Teilen, die weiter lesbar bleiben muessen. ausRoh() liefert fuer sie schlicht keinen Monat -
     ein fehlendes viertes Stueck ist kein Fehler, sondern ein alter Stand. */
  /* IST DIE FRAGE BEANTWORTET? (21.10.2026, Vorgabe Claras: "ich moechte bitte, dass man
     auswaehlen muss, ab wann man starten moechte, und wenn es eine konkrete Woche, Datum, dass
     man das auch auswaehlen muss").

     DIE REGEL STEHT HIER UND NICHT IM KONFIGURATOR: Welche Wahl einen Kalenderwert braucht,
     weiss dieses Modul - es baut den Kalender und kennt die Modi. Der Konfigurator fragt nur
     "fertig?" und muss dafuer nicht wissen, dass 'woche' einen Montag erwartet und 'monat' ein
     "2027-03".

     AUCH "SOBALD ES GEHT" BRAUCHT EIN DATUM (28.10.2026, Vorgabe Claras: "es muss bei 'sobald
     es geht', 'bestimmte Woche', 'bestimmter Monat' im Kalender etwas ausgewaehlt werden").
     Bis dahin war es die Antwort selbst und das Datum daneben freiwillig - wer den Kalender
     oeffnete und nichts anklickte, hatte "so frueh wie moeglich" gesagt. Jetzt gilt: Wer
     einen Kalender aufmacht, schliesst ihn auch. Ohne Kalender (6 Monate, weiss nicht) bleibt
     die Wahl allein die Antwort.

     WER EINEN KALENDER OEFFNET, STEHT IN KALENDER - EINMAL, FUER BEIDE FRAGEN. modusSetzen()
     brauchte dieselbe Zuordnung schon vorher; zwei Listen waeren beim naechsten neuen Zeitraum
     auseinandergelaufen, und zwar still: Der Kalender ginge auf, die Pflicht liefe ins Leere. */
  var KALENDER = {
    bald:  {modus:'tag',   feld:'datum'},
    woche: {modus:'woche', feld:'woche'},
    monat: {modus:'monat', feld:'monat'}
  };
  function vollstaendig(z){
    if(!z || !z.wahl) return false;
    var k=KALENDER[z.wahl];
    return !k || !!z[k.feld];
  }
  /* Woran es fehlt - fuer die Markierung an der richtigen Stelle: 'wahl' heisst, das
     Auswahlfeld steht noch leer, 'datum' heisst, die Wahl steht und der Kalender nicht. */
  function fehltWas(z){
    if(!z || !z.wahl) return 'wahl';
    return vollstaendig(z) ? null : 'datum';
  }
  function roh(z){
    if(!z || !z.wahl) return '';
    return z.wahl+'|'+(z.woche||'')+'|'+(z.datum||'')+'|'+(z.monat||'');
  }
  function ausRoh(s){
    var t=String(s||'').split('|');
    return {wahl:t[0]||'', woche:t[1]||null, datum:t[2]||null, monat:t[3]||null};
  }

  function monatHtml(jahr, monat, modus, gewaehlt){
    var min = (modus==='woche') ? minWoche() : minTag();
    var max = maxTag();
    var erster = new Date(jahr, monat, 1, 12,0,0,0);
    var vorlauf = (erster.getDay()+6)%7;             /* Montag = 0 */
    var tage = new Date(jahr, monat+1, 0).getDate();
    var zellen='', i, t;
    for(i=0;i<vorlauf;i++) zellen+='<span class="bwpkal-leer"></span>';
    for(t=1;t<=tage;t++){
      var d=new Date(jahr, monat, t, 12,0,0,0);
      var iso=tagText(d);
      var mon=montagVon(iso);
      var wert = (modus==='woche') ? tagText(mon) : iso;
      /* Im Wochenmodus entscheidet der MONTAG ueber die Sperre, nicht der einzelne Tag -
         sonst waere eine Woche halb anklickbar. */
      var pruef = (modus==='woche') ? mon : d;
      var gesperrt = pruef.getTime() < min.getTime() || d.getTime() > max.getTime();
      var sel = gewaehlt && wert===gewaehlt;
      zellen += '<button type="button" class="bwpkal-tag'+(sel?' sel':'')+'" data-wert="'+wert+'"'
              + (gesperrt?' disabled':'')+'>'+t+'</button>';
    }
    /* Nur Monate anbieten, in denen ueberhaupt etwas waehlbar ist. */
    var zuAus = new Date(jahr, monat, 0, 12,0,0,0).getTime() < min.getTime();
    var vorAus = new Date(jahr, monat+1, 1, 12,0,0,0).getTime() > max.getTime();
    return '<div class="bwpkal-kopf">'
      + '<button type="button" class="bwpkal-nav" data-m="-1" aria-label="Voriger Monat"'+(zuAus?' disabled':'')+'>‹</button>'
      + '<span class="bwpkal-monat">'+MONATE[monat]+' '+jahr+'</span>'
      + '<button type="button" class="bwpkal-nav" data-m="1" aria-label="Nächster Monat"'+(vorAus?' disabled':'')+'>›</button>'
      + '</div><div class="bwpkal-wochentage"><span>'+WOCHENTAGE.join('</span><span>')+'</span></div>'
      + '<div class="bwpkal-gitter'+(modus==='woche'?' ist-woche':'')+'">'+zellen+'</div>';
  }

  /* DAS MONATSGITTER (14.10.2026). Zwoelf Felder, ein Jahr je Ansicht, die Pfeile springen
     Jahre statt Monate.

     WANN IST EIN MONAT WAEHLBAR: sobald sein LETZTER Tag hinter der Vorlauffrist liegt - also
     sobald ueberhaupt noch etwas von ihm uebrig ist. Das weicht bewusst von der Wochenregel ab,
     die aufrundet und nur ganz hinter der Frist liegende Wochen anbietet: Eine Woche, von der
     drei Tage uebrig sind, ist als Termin unbrauchbar; ein Monat, von dem drei Wochen uebrig
     sind, ist eine voellig normale Antwort. Und die Frage ist ausdruecklich nur eine
     Orientierung, keine Terminzusage - das steht auch so darunter. */
  function monatsGitterHtml(jahr, gewaehlt){
    var min=minTag(), max=maxTag(), zellen='', m;
    for(m=0;m<12;m++){
      var letzter=new Date(jahr, m+1, 0, 12,0,0,0);
      var erster=new Date(jahr, m, 1, 12,0,0,0);
      var gesperrt = letzter.getTime() < min.getTime() || erster.getTime() > max.getTime();
      var wert = jahr+'-'+zwei(m+1);
      zellen += '<button type="button" class="bwpkal-mon'+(wert===gewaehlt?' sel':'')+'"'
              + ' data-wert="'+wert+'"'+(gesperrt?' disabled':'')+'>'+MONATE[m].slice(0,3)+'</button>';
    }
    var zuAus = new Date(jahr, 0, 0, 12,0,0,0).getTime() < min.getTime();
    var vorAus = new Date(jahr+1, 0, 1, 12,0,0,0).getTime() > max.getTime();
    return '<div class="bwpkal-kopf">'
      + '<button type="button" class="bwpkal-nav" data-j="-1" aria-label="Voriges Jahr"'+(zuAus?' disabled':'')+'>‹</button>'
      + '<span class="bwpkal-monat">'+jahr+'</span>'
      + '<button type="button" class="bwpkal-nav" data-j="1" aria-label="Nächstes Jahr"'+(vorAus?' disabled':'')+'>›</button>'
      + '</div><div class="bwpkal-monate">'+zellen+'</div>';
  }

  /* DER HINWEIS ZUM JANUAR (19.10.2026, Vorgabe Claras: "bei allen, wo man relativ spezifisch
     auswaehlen kann und erst ab Januar der Kalender angezeigt wird, Hinweis geben, dass wir
     aufgrund von hoher Nachfrage erst ab Januar neue Projekte annehmen, damit wir allen die
     besten Voraussetzungen bieten koennen").

     ER ERSCHEINT NUR, SOLANGE DIE GRENZE WIRKLICH GREIFT. Verglichen wird dasselbe wie in
     minTag(): Liegt heute+Vorlauffrist schon hinter START_AB, entscheidet wieder allein die
     Vorlauffrist - dann waere der Satz eine Behauptung ueber eine Sperre, die es nicht mehr
     gibt. Ab dem 28.11.2026 verschwindet er also von selbst, zusammen mit der Sperre.

     ER NENNT DEN MONAT AUS DER GRENZE und nicht "Januar" als Wort: Wer START_AB verschiebt,
     verschiebt den Satz mit. Eine getippte Jahreszahl waere beim naechsten Mal die falsche.

     ER STEHT IM KASTEN NEBEN DEM KALENDER, nicht darueber: Dort steht schon die gewaehlte
     Antwort und der Vorbehalt "nur zur Orientierung" - drei Saetze an einer Stelle sind
     leichter zu lesen als drei Saetze an drei Stellen.

     OHNE AUFZAEHLUNG, WAS WIR LEISTEN (Claras Entscheidung zum Wortlaut, 19.10.2026: "den
     oberen Satz, aber nicht so spezifisch mit dem Fachbetrieb-Termin und den Services, die wir
     anbieten"). Die erste Fassung nannte Auslegung, Material und Fachbetrieb-Termin - damit
     wurde aus einer Erklaerung, warum der Kalender spaeter beginnt, eine Leistungsliste an
     einer Stelle, an der niemand sie sucht. Und jede genannte Leistung ist eine Zusage mehr,
     die gelten muss. */
  function startAbHinweis(){
    if(!START_AB) return '';
    if(heutePlus(VORLAUF_TAGE).getTime() >= START_AB.getTime()) return '';
    var m=MONATE[START_AB.getMonth()], j=START_AB.getFullYear();
    return '<p class="startwunsch-abhinweis">'
      + '<b>Dein Projekt starten wir ab ' + esc(m) + ' ' + j + '</b> – dann beginnen Planung '
      + 'und Lieferung. Die Nachfrage ist gerade hoch, und wir nehmen bewusst nur so viele '
      + 'Projekte an, wie wir wirklich begleiten können.'
      + '</p>';
  }

  function html(id, z, titel){
    var optionen='', i;
    /* DER PLATZHALTER STEHT VORNE, SOLANGE NICHTS GEWAEHLT IST (21.10.2026, Vorgabe Claras).
       Ohne ihn zeigt ein <select> immer seinen ersten Eintrag - der Kunde saehe "Sobald es
       geht" und haelte die Frage fuer beantwortet, waehrend nichts gespeichert ist. disabled
       haelt ihn davon ab, wieder auf "nichts" zurueckzugehen; sobald eine Wahl steht, faellt
       er ganz weg, damit er nicht als Antwort in der Liste steht. */
    if(!(z && z.wahl))
      optionen += '<option value="" disabled selected>Bitte ausw\u00e4hlen \u2026</option>';
    for(i=0;i<WAHL.length;i++)
      optionen += '<option value="'+WAHL[i].k+'"'+((z&&z.wahl)===WAHL[i].k?' selected':'')+'>'+esc(WAHL[i].label)+'</option>';
    return '<div class="startwunsch" id="'+id+'">'
      + '<label class="startwunsch-titel" for="'+id+'Feld">'+esc(titel||'Ab wann möchtest du starten?')+'</label>'
      /* DER VORBEHALT STEHT NEBEN DEM AUSWAHLFELD (19.10.2026, Vorgabe Claras: "das 'nur zur
         Orientierung ...' bitte neben das Auswahl-Dropdown tun und nur eine Zeile machen, also
         kuerzen").

         ER STAND BISHER UNTEN IM KASTEN NEBEN DEM KALENDER - also an einer Stelle, die man
         erst sieht, wenn man schon etwas ausgewaehlt hat. Der Vorbehalt gilt aber fuer die
         Auswahl selbst: Er gehoert dorthin, wo sie getroffen wird.

         GEKUERZT AUF EINEN SATZ. Der zweite ("Wir melden uns nach deiner Bestellung und
         stimmen Lieferung bzw. Abholung mit dir ab") ist ersatzlos entfallen - er sagte, was
         danach passiert, und das steht im Kaufkasten und in der Bestellbestaetigung ohnehin.
         Der verbleibende Satz traegt die eigentliche Aussage: Es ist ein Wunsch, kein Termin. */
      + '<div class="startwunsch-kopf">'
      +   '<select class="startwunsch-select" id="'+id+'Feld">'+optionen+'</select>'
      +   '<p class="startwunsch-hinweis">Nur zur Orientierung – kein verbindlicher Termin.</p>'
      + '</div>'
      + '<div class="startwunsch-reihe">'
      +   '<div class="bwpkal" hidden></div>'
      +   '<div class="startwunsch-neben">'
      +     '<p class="startwunsch-wert">'+esc(text(z))+'</p>'
      +     startAbHinweis()
      +   '</div>'
      + '</div></div>';
  }

  function verdrahten(id, z, beiAenderung){
    var box=document.getElementById(id); if(!box) return;
    var feld=box.querySelector('.startwunsch-select');
    var kal=box.querySelector('.bwpkal');
    var wertZeile=box.querySelector('.startwunsch-wert');
    /* Der gezeigte Monat lebt nur, solange der Kalender offen ist - beim naechsten Oeffnen
       steht er wieder auf dem der Auswahl bzw. dem ersten moeglichen. */
    var zeigeJahr=0, zeigeMonat=0, modus=null;
    function gewaehlt(){ return modus==='woche' ? z.woche : modus==='monat' ? z.monat : z.datum; }
    function startpunkt(){
      /* Im Monatsmodus ist der gemerkte Wert "2026-03" und kein Tag - tagAus() koennte ihn
         nicht lesen. Deshalb hier der eigene Zweig. */
      if(modus==='monat'){
        var t=String(z.monat||'').split('-');
        var j=(t.length===2) ? +t[0] : minTag().getFullYear();
        return new Date(j, 0, 1, 12,0,0,0);
      }
      var g=gewaehlt();
      var d = g ? tagAus(g) : (modus==='woche' ? minWoche() : minTag());
      return new Date(d.getFullYear(), d.getMonth(), 1, 12,0,0,0);
    }
    function melden(){
      if(wertZeile) wertZeile.textContent=text(z);
      if(typeof beiAenderung==='function') beiAenderung(z);
    }
    function zeichnen(){
      if(!modus){ kal.hidden=true; kal.innerHTML=''; return; }
      kal.hidden=false;
      kal.innerHTML = (modus==='monat')
        ? monatsGitterHtml(zeigeJahr, gewaehlt())
        : monatHtml(zeigeJahr, zeigeMonat, modus, gewaehlt());
      Array.prototype.forEach.call(kal.querySelectorAll('.bwpkal-nav:not([disabled])'), function(b){
        b.addEventListener('click', function(){
          /* Im Tages- und Wochengitter springen die Pfeile Monate (data-m), im Monatsgitter
             Jahre (data-j). Ein Knopf, zwei Schrittweiten - der Unterschied steht im Markup
             und nicht in einer zweiten Funktion. */
          var jahrSchritt=b.getAttribute('data-j');
          if(jahrSchritt){ zeigeJahr += (+jahrSchritt); zeichnen(); return; }
          var d=new Date(zeigeJahr, zeigeMonat + (+b.getAttribute('data-m')), 1, 12,0,0,0);
          zeigeJahr=d.getFullYear(); zeigeMonat=d.getMonth(); zeichnen();
        });
      });
      Array.prototype.forEach.call(kal.querySelectorAll('.bwpkal-tag:not([disabled]),.bwpkal-mon:not([disabled])'), function(b){
        b.addEventListener('click', function(){
          var w=b.getAttribute('data-wert');
          if(modus==='woche') z.woche=w; else if(modus==='monat') z.monat=w; else z.datum=w;
          zeichnen(); melden();
        });
      });
    }
    function modusSetzen(){
      /* Nur die drei datierten Wahlen oeffnen einen Kalender. "In 6 Monaten" und "weiss ich
         nicht" sind die Antwort selbst - ein Kalender daneben waere die Aufforderung, sie doch
         genauer zu machen. Die Zuordnung steht in KALENDER, gemeinsam mit vollstaendig(). */
      modus = (KALENDER[z.wahl] || {}).modus || null;
      if(modus){ var s=startpunkt(); zeigeJahr=s.getFullYear(); zeigeMonat=s.getMonth(); }
    }
    if(feld) feld.addEventListener('change', function(){
      z.wahl=feld.value; modusSetzen(); zeichnen(); melden();
    });
    /* Beim Aufbau nicht nur das Feld stellen, sondern auch den Kalender - wer mit einer
       gewaehlten Woche zurueckkommt, soll sie sehen und nicht erst wieder aufklappen. */
    modusSetzen(); zeichnen();
  }

  window.BwpStartwunsch = {
    WAHL: WAHL, text: text, roh: roh, ausRoh: ausRoh,
    vollstaendig: vollstaendig, fehltWas: fehltWas,
    html: html, verdrahten: verdrahten,
    VORLAUF_TAGE: VORLAUF_TAGE, FENSTER_TAGE: FENSTER_TAGE
  };
})();
